import { useEffect, useRef } from 'react';

// Makes the browser/Android back button close an open full-screen layer
// (the phone voice sheet) instead of navigating the page underneath it -
// on Android, back is how people dismiss anything that covers the screen.
//
// While `open`, one extra history entry sits on top (same URL, marked in
// its state); back pops it and we close. Closing any other way (the
// collapse button, leaving the room) takes that entry back off, so the
// next back press still means "previous page". react-router just sees a
// popstate to the same path either way.
export function useBackToClose(open, onClose) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    window.history.pushState({ ...(window.history.state || {}), cycloneLayer: true }, '');
    let poppedByBack = false;
    const onPopState = () => {
      poppedByBack = true;
      onCloseRef.current();
    };
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
      if (!poppedByBack && window.history.state && window.history.state.cycloneLayer) window.history.back();
    };
  }, [open]);
}
